import React, { useEffect } from 'react';
import { Box, HStack, ScrollView, VStack, useTheme } from 'native-base';
import Channel from './Channel';
import { useCategoriesDispatch, useCategoriesState } from '../../../context/categories';
import { useEnvState } from '../../../context/env';
import { CHANNEL_PHOTO_INDEX } from '../../Constants';
const Channels = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const categoriesState = useCategoriesState();
  const {
    forumCategories: baseChannels,
    allPostsImagePaths
  } = categoriesState;
  const categoriesDispatch = useCategoriesDispatch();
  const setSelectedCategory = item => {
    categoriesDispatch({
      type: 'SET_SELECTED_CATEGORY',
      payload: item
    });
  };
  const selectedCategory = categoriesState.selectedCategory;
  const envState = useEnvState();
  const {
    product
  } = envState;
  let channels = [];
  if (baseChannels) {
    if (baseChannels.length > 1) {
      if (product.match(/pbcc/)) {
        // we don't want "All Posts" in this case
        channels = baseChannels;
      } else {
        // we want an "All Posts" channel otherwise
        const allPostsChannel = {
          id: -1,
          name: 'All Posts',
          uploaded_logo: {
            url: allPostsImagePaths.icon
          },
          uploaded_background: {
            url: allPostsImagePaths.header
          }
        };
        channels = [allPostsChannel, ...baseChannels];
      }
    } else if (baseChannels.length == 1) {
      channels = [{
        ...baseChannels[0],
        name: 'All Posts'
      }];
    }
  }
  useEffect(() => {
    if (!selectedCategory) {
      if (channels.length == 1) {
        setSelectedCategory(channels[0]);
      }
      if (product.match(/pbcc/)) {
        // set selected category to the last channel by default
        setSelectedCategory(channels.slice(-1)[0]);
      }
    }
  }, [channels]);
  const OverviewChannels = () => {
    return /*#__PURE__*/React.createElement(Box, {
      w: '100%'
    }, /*#__PURE__*/React.createElement(HStack, {
      bg: colors.menu.channels.bg,
      px: 2,
      py: 4,
      w: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    }, /*#__PURE__*/React.createElement(ScrollView, {
      horizontal: true,
      showsHorizontalScrollIndicator: false,
      showsVerticalScrollIndicator: false
    }, /*#__PURE__*/React.createElement(HStack, {
      space: 3,
      justifyContent: 'space-around',
      alignItems: 'center'
    }, channels.map((item, i) => {
      const channelImage = item.uploaded_logo && item.uploaded_logo.url ? `https:${item.uploaded_logo.url}` : `https://picsum.photos/id/${CHANNEL_PHOTO_INDEX + i}/200`;
      return /*#__PURE__*/React.createElement(Channel, {
        key: item.id.toString() + item.name,
        item: item,
        selectedCategory: selectedCategory,
        setSelectedCategory: setSelectedCategory,
        channelImage: channelImage,
        orientation: props.orientation,
        setPage: props.setPage,
        setHasMoreTopics: props.setHasMoreTopics
      });
    })))));
  };
  const SideMenuChannels = () => {
    return /*#__PURE__*/React.createElement(VStack, {
      w: '100%'
    }, channels.map((item, i) => {
      const channelImage = item.uploaded_logo && item.uploaded_logo.url ? `https:${item.uploaded_logo.url}` : `https://picsum.photos/id/${CHANNEL_PHOTO_INDEX + i}/200`;
      return /*#__PURE__*/React.createElement(Channel, {
        key: item.id.toString() + item.name,
        item: item,
        selectedCategory: selectedCategory,
        setSelectedCategory: setSelectedCategory,
        channelImage: channelImage,
        orientation: props.orientation,
        setPage: props.setPage,
        setHasMoreTopics: props.setHasMoreTopics
      });
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.orientation === 'horizontal' && /*#__PURE__*/React.createElement(OverviewChannels, null), props.orientation === 'vertical' && /*#__PURE__*/React.createElement(SideMenuChannels, null));
};
export default Channels;
//# sourceMappingURL=Channels.js.map